export default {
  computed: {
    renderAlbum() {
      return this.$store.getters.RENDER_ALBUM;
    }
  }
};
